<template>
  <v-bottom-navigation
    :key="$route.name"
    app
    grow
    color="primary"
  >
    <v-btn
      v-if="![$store.state.centralizedWorkspace, 'spontaneous'].includes(activeWorkspace)"
      value="/"
      :to="{ name: 'home' }"
      color="transparent"
      class="pointer text-capitalize"
      exact
    >
      Dashboard

      <v-icon class="transparent">mdi-home</v-icon>
    </v-btn>

    <template
      v-for="(item, itemIndex) in filteredItems"
    >
      <v-btn
        v-if="!item.hideBottomMenu"
        :key="itemIndex"
        :value="item.id"
        v-bind="getNavigationConfig(item)"
        color="transparent"
        class="pointer text-capitalize"
        :disabled="!canAccessRoute(item.path)"
      >
        {{ item.text }}

        <v-icon class="transparent">{{ getIcon(item.wtype) }}</v-icon>
      </v-btn>
    </template>
  </v-bottom-navigation>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'BottomNavigation',
  computed: {
    ...mapState(['activeWorkspace', 'references']),
    ...mapGetters(['canAccessRoute', 'contentTypeList']),
    filteredItems () {
      return this.contentTypeList.filter(item => {
        let forbiddenActions = [];
        switch (this.activeWorkspace) {
          case 'spontaneous':
            forbiddenActions = ['jobs', 'offers', 'applications', 'candidates', 'model-offers-list'];
            break;
          case this.$store.state.centralizedWorkspace:
            forbiddenActions = ['applications', 'candidates', 'applications-spontaneous-list', 'vivier'];
            break;
          default:
            forbiddenActions = ['application', 'model-offers-list', 'applications-spontaneous-list'];
            break;
        }

        return !forbiddenActions.includes(item.id);
      });
    }
  },
  methods: {
    getNavigationConfig (item) {
      const config = {};

      switch (item.wtype) {
        case 'application': {
          if (item.label === 'candidatures-spontanees') {
            config.to = { name: 'candidature-spontanee-list' };
          }
          break;
        }// eslint-disable-next-line no-fallthrough
        case 'job':
          config.to = {
            name: 'jobs',
            params: { contentTypeLabel: item.label }
          };

          break;
        case 'offer':
          config.to = {
            name: 'offers',
            params: { contentTypeLabel: item.label }
          };

          break;
        case 'model_offer':
          config.to = {
            name: 'model-offers-list',
            params: { contentTypeLabel: item.label }
          };

          break;
        case 'vivier':
          config.to = { name: 'vivier-search' };
          break;
        case 'link':
          config.href = item.value;
          break;
        default:
          console.error('Navigation type not found:', item.wtype);
          config.to = { name: 'home' };
      }

      return config;
    },
    getIcon (wtype) {
      switch (wtype) {
        case 'offer':
          return 'mdi-book-multiple';
        case 'job':
          return 'mdi-briefcase';
        case 'candidate':
          return 'mdi-folder-account';
        case 'application':
          return 'mdi-application';
        case 'model_offer':
          return 'mdi-axis-arrow';
        case 'vivier':
          return 'mdi-database';
        default:
          return '';
      }
    }
  }
};
</script>
